
import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import Draggable from 'vuedraggable'
import DisplayItem from './DisplayItem.vue'

@Component({
  components: { DisplayItem, Draggable }
})
export default class ItemList extends Vue {
  @Prop({ required: true, type: Array }) items!: any[]
  @Prop({ default: false, type: Boolean }) sortable!: boolean
  @Prop({ default: 'artist-item', type: String }) itemRowClass!: string
  @Prop({ default: 'Delete', type: String }) deleteButtonText!: string
  @Prop({ default: 'mdi-help', type: String }) defaultIcon!: string
  @Prop({ default: null, type: Function }) getItemTitle!: ((item: any) => string) | null
  @Prop({ default: null, type: Function }) getItemSubtitle!: ((item: any) => string) | null
  @Prop({ default: null, type: Function }) getItemImage!: ((item: any) => string) | null
  @Prop({ default: null, type: Function }) getItemKey!: ((item: any, index: number) => string) | null

  get localItems () {
    return this.items
  }

  set localItems (value: any[]) {
    this.$emit('input', value)
  }

  @Emit('sort')
  onSort () {
    return this.localItems
  }

  @Emit('remove')
  removeItem (index: number): { item: any; index: number } {
    const item = this.localItems[index]
    const newItems = this.localItems.filter((_, i) => i !== index)
    this.$emit('input', newItems)
    return { item, index }
  }
}
